import { Box } from '@chakra-ui/react';
import { DashboardTemplate } from '../../components/templates/DashboardTemplate.tsx';
import { PlanMappingContent } from '../PlanMapping/index.tsx';

export default function MapeamentoPlanosPage() {
  return (
    <DashboardTemplate>
      <Box width="100%" maxW="100%">
        <PlanMappingContent />
      </Box>
    </DashboardTemplate>
  );
}
